import React from 'react';
import './preview-dialog-box.sass';
import PigeonMdm from '../../assets/preview/Pigeon_mdm.png';
import PigeonMobile from '../../assets/preview/Pigeon_mobile.png';
import PigeonSmm from '../../assets/preview/Pigeon_smm.png';
import Pigeon from '../../assets/preview/Pigeon.png';

export const PreviewDialogBox = () => {

    return (
      <div className='vv-preview-dialog-box-container'>
          <div className='vv-preview-dialog-box vv-preview-dialog-box--big triangle-bottom-left'>
              <p>Szukaj wydarzeń i zgarniaj zniżki do najlepszych miejscówek w Krakowie!</p>
          </div>
          <div className='vv-preview-dialog-box vv-preview-dialog-box--small triangle-bottom-right'>
              <p>Coś?</p>
          </div>
          <div className='vv-preview-dialog-box vv-preview-dialog-box--medium'>
              <p>Ktoś?</p>
          </div>
          <div className='vv-preview-pigeon-container'>
              <picture>
                  <source media='(min-width: 1250px)' srcSet={Pigeon}/>
                  <source media='(min-width: 920px)' srcSet={PigeonMdm}/>
                  <source media='(min-width: 500px)' srcSet={PigeonSmm}/>
                  <img className='vv-preview-pigeon-image' src={PigeonMobile} alt='Pigeon'/>
              </picture>
          </div>
      </div>
    );
};
